<template>
  <div>
    <!-- メイン -->
    <v-main>
      <v-container class="pt-0">

        <!-- <v-card flat max-height="10vh" class="mb-6">
          <v-row>
            <v-col cols="12" class="d-flex align-center justify-center text-h4 text-sm-h4 text-lg-h3 text-xl-h3">
              <span class="vf-font-title" style="font-weight: bold; font-size: 0.8em;">本人確認用お顔のご登録</span>
            </v-col>
          </v-row>
        </v-card> -->

        <v-card flat max-height="16vh" class="mb-2">
          <v-row class="mt-2 mb-1 px-0">
            <v-col cols="1"></v-col>
            <v-col cols="10" class="d-flex align-center justify-center text-h6 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4">
              <span> {{ docDetailName }}全体が、おさまるようにカメラで撮影してください。</span>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-card>

        <v-card flat max-height="40vh" class="mb-2">
          <v-row class="capture-row">
            <v-col cols="12" class="d-flex align-center justify-center px-0">
              <template v-if="mode = 'user'">
                <!-- <video ref="video" id="video" :width="cameraWidth" height="auto" autoplay loop muted playsinline style="-webkit-transform: scaleX(-1);" ></video> -->
                <video ref="video" id="video" :width="cameraWidth" height="auto" autoplay loop muted playsinline :style="cameraTransform" ></video>
              </template>
              <template v-else>
                <video ref="video" id="video" :width="cameraWidth" height="auto" autoplay loop muted playsinline ></video>
              </template>
              <canvas ref="canvas" id="canvas" :width="cameraImgWidth" :height="cameraImgHeight"></canvas>
            </v-col>
            <v-btn x-large fab color="grey lighten-2" dark @click="capture()" class="text-h5 capture">
              <v-icon color="grey">mdi-camera</v-icon>
            </v-btn>
            <v-btn fab color="grey lighten-2" @click="switching()" class="text-h5 switching">
              <v-icon color="grey">mdi-camera-flip-outline</v-icon>
            </v-btn>
          </v-row>

          <v-card flat max-height="10vh" class="mb-6">
            <v-row>
              <template v-if="this.hiddenFlg">
                <v-col cols="12" class="d-flex align-center justify-center">
                  <v-btn large fab color="success" min-width="60px" @click="back()" class="black--text">はじめから</v-btn>
                </v-col>
              </template>
              <template v-else>
                <v-col cols="6" class="d-flex align-center justify-center pb-0 pl-6 pl-sm-6 pl-lg-16 pl-xl-16">
                  <v-btn large fab color="success" min-width="60px" @click="back()" class="black--text">はじめから</v-btn>
                </v-col>
                <v-col cols="6" class="d-flex align-center justify-center pb-0 pr-6 pr-sm-6 pr-lg-16 pr-xl-16">
                  <!-- <v-btn small fab color="grey darken-2" @click="switching()" class="text-h5">
                    <v-icon color="white">mdi-camera-flip-outline</v-icon>
                  </v-btn> -->
                </v-col>
              </template>
            </v-row>
          </v-card>

          <v-row class="mt-0">
            <v-col cols="12" class="d-flex align-center justify-center">
              <!-- <v-img src="@/assets/img/body_face_side_woman.png" :max-width="imageStepWidth"></v-img> -->
              <v-img src="@/assets/img/body_face_side_man.png" :max-width="imageStepWidth"></v-img>
            </v-col>
          </v-row>
        </v-card>

      </v-container>
    </v-main>

    <comMessageConfirm :msg="dlgMsgBackConfirm.msg" :isOpen="dlgMsgBackConfirm.isOpen" :doYes="dlgMsgBackConfirm.doYes" :doNo="dlgMsgBackConfirm.doNo" />
    <!-- ダイアログボタン -->
    <v-dialog v-model="cameraDialog" :max-width="cameraDialogWidth" class="ma-0">
      <v-card>
        <v-container class="px-0 py-0">
          <v-row no-gutters >
            <v-col cols="12" class="d-flex align-center justify-center">
              <v-img v-bind:src="captureUrl" height="auto"></v-img>
            </v-col>
          </v-row>
        </v-container>
        <v-card-title class="d-flex align-center justify-center pt-1 pb-1 px-0">
          <p class="text-body-1 text-sm-body-1 text-md-h6 text-xl-h6 mb-0 text-caption">
          申請する場合は「申請」撮り直す場合は「撮り直す」
          </p>
        </v-card-title>
        <!-- ダイアログボタン -->
        <v-card-actions  class="pt-0">
          <v-row no-gutters  class="mb-0">
            <v-col cols="6" class="d-flex align-center justify-center">
              <v-btn x-large color="success" dark min-width="120px" @click="closeCameraDialog">撮り直す</v-btn>
            </v-col>
            <v-col cols="6" class="d-flex align-center justify-center">
              <v-btn x-large color="success" dark min-width="120px" :disabled="initializeErr" @click="saveCameraDialog">申請</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- その他 -->
    <comMessage :msg="dlgMsgErr.msg" :isOpen="dlgMsgErr.isOpen" :doYes="dlgMsgErr.doYes"/>
  </div>
</template>
<script>
import Constants from "../common/constantsVf";
import Utils from "../common/utils";
export default {
  name: "VFFacePhoto2",
  data() {
    return {
      screenTitle: "顔撮影（斜め）",
      screenId: "APA410",
      accesskey: "",
      receiptNo: "",
      systemId: "",
      docDetailName: "",
      initializeErr: false,
      photoData: null,
      video: {},
      canvas: {},
      captureUrl: "", 
      captureBlob: "",
      mode: "user",
      cameraFacing: false, 
      cameraDialog: false,
      cameraImgWidth: "", 
      cameraImgHeight: "", 
      hiddenFlg: false,
      cameraTransform: "",
      dlgMsgBackConfirm: {
        msg: this.$i18n.t('msg.wrn.apv010'),
        isOpen: false,
        doYes: () => {
          // カメラストップ
          this.stopVideoMixin(this);
          // 遷移
          this.$router.push( this.$router.resolve({ name: 'APA100', params: {accesskey: this.accesskey, receiptno: this.receiptNo, systemid: this.systemId} }).href);
          this.dlgMsgBackConfirm.isOpen = false;
        },
        doNo: () => {
          this.dlgMsgBackConfirm.isOpen = false;
        },
      },
      dlgMsgErr: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgErr.isOpen = false;
        },
      },
    };
  },
  computed: {
    cameraWidth: function() {
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        return "100%";
      } else if (bp == 'md' || bp == 'sm') {
        return "80%";
      } else if (bp == 'lg') {
        return "70%";
      } else if (bp == 'xl') {
        return "55%";
      } else {
        return "100%";
      }
    },
    imageStepWidth() {
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        return "50%";
      } else if (bp == 'sm' || bp == 'md') {
        return "40%";
      } else if (bp == 'lg') {
        return "28%";
      } else if (bp == 'xl') {
        return "18%";
      } else {
        return "18%";
      }
    },
    cameraDialogWidth() {
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        return "80%";
      } else if (bp == 'md' || bp == 'sm') {
        return "70%";
      } else if (bp == 'lg') {
        return "50%";
      } else if (bp == 'xl') {
        return "40%";
      } else {
        return "80%";
      }
    }
  },
  created() {
    this.initialize();
  },
  mounted () {
      // キャプチャ画像のサイズを決める
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        this.cameraImgWidth = 600;
        this.cameraImgHeight = 800;
      } else if (bp == 'md' || bp == 'sm' || bp == 'xl' || bp == 'lg') {
        this.cameraImgWidth = 800;
        this.cameraImgHeight = 600;
      } else {
        this.cameraImgWidth = 600;
        this.cameraImgHeight = 800;
      }

    this.video = this.$refs.video
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            
      if(!navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)){
        // PCの場合はカメラの切り替えボタンを非表示にする
        this.hiddenFlg = true;
        this.mode = "user";
      }
      this.changeCameraTransform();
      navigator.mediaDevices.getUserMedia({ video: {facingMode: this.mode } }).then(stream => {
        this.video.srcObject = stream;
        this.video.play();
      });
    }
  },
  methods: {

    /**
     * 初期表示
     */
    initialize: function() {
      this.accesskey = this.$store.getters["vfAppInfo/getAccesskey"];
      this.receiptNo = this.$store.getters["vfAppInfo/getReceiptNo"];
      this.systemId = this.$store.getters["vfAppInfo/getSystemId"];
      let docDetailKbnList =  this.$store.getters["vfMaster/getDocDetailKbnList"];
      this.docDetailName = this.searchKbnNameByCdMixin(docDetailKbnList, Constants.APP_DOCUMENT_DETAIL_FACE_DIAGOBAL);
    },

    back: function() {
      this.dlgMsgBackConfirm.isOpen = true;
    },

    /**
     *カメラ切り替えボタン押下
     */
    switching: function() {
      let vi = document.querySelector('video');
      
      // 現在動いているカメラを停止
      if (this.video.srcObject !== null){
          // カメラストップ
          this.stopVideoMixin(this);
      }

      if (this.cameraFacing){
        this.mode = "user";
      } else {
        this.mode = "environment";
      }
      this.changeCameraTransform();
      // カメラ切り替え
      navigator.mediaDevices.getUserMedia({ video: { facingMode: this.mode } })
            .then(stream => vi.srcObject = stream)
            .catch(err => alert(`${err.name} ${err.message}`));
        this.cameraFacing = !this.cameraFacing;
    },
    changeCameraTransform: function() {
      this.cameraTransform = "";
      if (this.mode === "user") {
        this.cameraTransform = "-webkit-transform: scaleX(-1);";
      }
    },

    capture: function() {
      this.canvas = this.$refs.canvas;
      this.canvas.getContext('2d').drawImage(this.video, 0, 0, this.cameraImgWidth, this.cameraImgHeight);
      this.initializeErr = false;
      this.setCanvasUrlMixin(this);
    },

    closeCameraDialog: function() {
      this.captureUrl = "";
      this.cameraDialog = false;
    },

    saveCameraDialog: function() {
      let receiptNo = this.$store.getters["vfAppInfo/getReceiptNo"];
      let systemId = this.$store.getters["vfAppInfo/getSystemId"];
      this.fileDataRegister(systemId, receiptNo);
    },

    /*
    * 確認申請登録
    * 確認状態更新
    */
    fileDataRegister: async function(systemId, receiptNo){
      // サービス呼び出し
      let responseData = null;
      let apiErrorInfo = null;
      console.log(receiptNo);
      let apiurl = Constants.getUrlApiAPA410P01(systemId, receiptNo, null, Constants.APP_DOCUMENT_DETAIL_FACE_DIAGOBAL); 
      let data = new FormData();
      data.append('fileData', this.captureBlob);
      try {
        let response = await this.$axios.post(apiurl, data,
            {
              headers: {"content-type": "multipart/form-data"},
              responseType: "json",
            });
         responseData = response.data
         // 完了メッセージ表示
        this.showDialogMsgAfterAPICall(this.dlgMsgErr, apiErrorInfo, responseData)
      } catch(error) {
          apiErrorInfo = error;
          if (this.$axios.isAxiosError(error) && error.response) {
           console.log(error.response.data);
         }
          this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm110', ['撮影画像の登録']);
          this.dlgMsgErr.isOpen = true;
          this.initializeErr = true;
      }       
    },

    /*
    * 完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(dialog, apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        dialog.msg = this.$i18n.t('msg.err.cm110', ['撮影画像の登録']);
        dialog.isOpen = true;
        this.initializeErr = true;
        return hasError;
      }
      // API処理異常
      if (responseData.statusCd === 500) {
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          dialog.msg = Utils.createMsgViewStringForErrList(errorList);
          dialog.isOpen = true;
        }else{
          dialog.msg = responseData.message ;
          dialog.isOpen = true;
          
        }
        this.initializeErr = true;
        return hasError;
      } else {
        // API処理正常
        // カメラストップ
        this.stopVideoMixin(this);
        this.cameraDialog = false;
        // 遷移
        this.$router.push(this.$router.resolve({ name: 'APA500' }).href);
      }
    },    
  },
}
</script>
<style scoped>
#canvas {
  display: none;
}
/* .guidline {
  outline: dashed 3px green;
  outline-offset: -40px;
} */

.capture-row {
  position:  relative; 
}

.capture {
  position: absolute;
  bottom: 1%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.switching{
  position: absolute;
  top: 3%;
  right: 11%;
  transform: translate(70%, 10%);
  opacity: 0;
}

@media screen and (max-width: 750px) {
  .switching{
    position: absolute;
    top: 3%;
    right: 11%;
    transform: translate(70%, 10%);
    opacity: 1;
  }
}
</style>